import { useQuery } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';
import { Project } from 'Interfaces/FeatureFlip';

const getAllProjects = async (name:string) => {
  try {
    const url = paths.getAllProjects();
    const response = await axiosInstance.post(url, {input: {
      pageNumber:1,
      pageSize:100,
      query:name?`name==%${name}%`:null
    }});
    const projects = response?.data?.data?.projects?.result;

    return Array.isArray(projects) ? projects as Project[] : [];
  } catch (error) {
    return Promise.reject(error);
  }
  
};



export const useGetAllProjects = (name:string) => {
  return useQuery(['get-all-projects',name], ()=>getAllProjects(name), {
    enabled: false 
  });
};